var cst_samsunggalaxys9 =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_samsunggalaxys9 =5.00;
var tsz_samsunggalaxys9= [24,36,60];

var cst_samsunggalaxys9s9plus =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_samsunggalaxys9s9plus =5.00;
var tsz_samsunggalaxys9s9plus= [24,36,60];

var cst_iphonex =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphonex =4.90;
var tsz_iphonex= [24,36,60];

var cst_iphonexs =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphonexs =4.90;
var tsz_iphonexs= [24,36,60];

var cst_iphonexsmax =[[50, 29.5, 0, 0.7], [50, 45, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphonexsmax =4.60;
var tsz_iphonexsmax= [24,36,60];

var cst_iphonexr =[[50, 29, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphonexr =4.90;
var tsz_iphonexr= [24,36,60];

var cst_iphone8 =[[50, 30, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone8 =4.60;
var tsz_iphone8= [24,36,60];

var cst_iphone8plus =[[50, 27.5, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone8plus =4.60;
var tsz_iphone8plus= [24,36,60];

var cst_iphone7 =[[50, 30, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone7 =4.60;
var tsz_iphone7= [24,36,60];

var cst_iphone7plus =[[50, 27.5, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone7plus =4.60;
var tsz_iphone7plus= [24,36,60];

var cst_iphone66s =[[50, 30, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone66s =4.60;
var tsz_iphone66s= [24,36,60];

var cst_iphone6plus6splus =[[50, 27.5, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone6plus6splus =4.60;
var tsz_iphone6plus6splus= [24,36,60];

var cst_iphone55s =[[50, 29.5, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone55s =4.90;
var tsz_iphone55s= [24,36,60];

var cst_pouch =[[50, 24, 3, 0.7], [50, 50, 0, 0.7], [84.5, 75, 0, 0.7]];
var csz_pouch =9.00;
var tsz_pouch= [24,36,60];

var cst_iphone11 =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone11 =4.90;
var tsz_iphone11= [24,36,60];

var cst_iphone11pro =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone11pro =4.90;
var tsz_iphone11pro = [24,36,60];

var cst_iphone11promax =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone11promax =4.90;
var tsz_iphone11promax= [24,36,60];

var cst_samsunggalaxys10 =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_samsunggalaxys10 =5.00;
var tsz_samsunggalaxys10= [24,36,60];

var cst_samsunggalaxys10plus =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_samsunggalaxys10plus =5.00;
var tsz_samsunggalaxys10plus= [24,36,60];

var cst_samsunggalaxys10e =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_samsunggalaxys10e =5.00;
var tsz_samsunggalaxys10e= [24,36,60];

var cst_cardholderblcroc =[[50.5, 43, 3, 0.7], [50.5, 56.5, 0, 0.7], [50.5, 67, 0, 0.7]];
var csz_cardholderblcroc =5.00;
var tsz_cardholderblcroc = [24,36,60];

var cst_cardholderblsaf =[[50.5, 43, 3, 0.7], [50.5, 56.5, 0, 0.7], [50.5, 67, 0, 0.7]];
var csz_cardholderblsaf =5.00;
var tsz_cardholderblsaf = [24,36,60];

var cst_cardholdercaramel =[[50.5, 43, 3, 0.7], [50.5, 56.5, 0, 0.7], [50.5, 65, 0, 0.7]];
var csz_cardholdercaramel =5.00;
var tsz_cardholdercaramel = [24,36,60];

var cst_cardholderpinkcroc =[[50.5, 41, 3, 0.7], [50.5, 57, 0, 0.7], [50.5, 65, 0, 0.7]];
var csz_cardholderpinkcroc =5.00;
var tsz_cardholderpinkcroc = [24,36,60];

var cst_cardholderwhcroc =[[50.5, 42, 3, 0.7], [50.5, 57, 0, 0.7], [50.5, 65, 0, 0.7]];
var csz_cardholderwhcroc =5.00;
var tsz_cardholderwhcroc = [24,36,60];

var cst_toteblcroc =[[48.8, 36.3, 3, 0.7], [48.8, 55, 0, 0.7], [48.8, 74, 0, 0.7]];
var csz_toteblcroc =21.00;
var tsz_toteblcroc = [24,36,60];

var cst_toteblsaf =[[49.6, 38.5, 3, 0.7], [49.6, 58, 0, 0.7], [49.6, 77, 0, 0.7]];
var csz_toteblsaf =21.00;
var tsz_toteblsaf = [24,36,60];

var cst_halfmoonpinkcroc =[[50, 27, 3, 0.7], [50, 49, 0, 0.7], [50, 70, 0, 0.7]];
var csz_halfmoonpinkcroc =13.40;
var tsz_halfmoonpinkcroc = [24,36,60];

var cst_halfmoonblsaf =[[48.7, 23.5, 3, 0.7], [49, 49, 0, 0.7], [50, 71, 0, 0.7]];
var csz_halfmoonblsaf =13.40;
var tsz_halfmoonblsaf = [24,36,60];

var cst_halfmoonblsmooth =[[50, 22.8, 3, 0.7], [50, 49, 0, 0.7], [50, 70, 0, 0.7]];
var csz_halfmoonblsmooth =13.40;
var tsz_halfmoonblsmooth = [24,36,60];

var cst_halfmooncaramelsmooth =[[50, 32.5, 3, 0.7], [50, 50, 0, 0.7], [50, 72, 0, 0.7]];
var csz_halfmooncaramelsmooth =13.50;
var tsz_halfmooncaramelsmooth = [24,36,60];

var cst_halfmoonblcroc =[[49.8, 26.5, 3, 0.7], [49.8, 49, 0, 0.7], [49.8, 69, 0, 0.7]];
var csz_halfmoonblcroc =13.40;
var tsz_halfmoonblcroc = [24,36,60];

var cst_circleblcroc =[[50, 49.3, 3, 0.7], [50, 65, 0, 0.7], [51, 89, 0, 0.7]];
var csz_circleblcroc =13.50;
var tsz_circleblcroc = [24,36,60];

var cst_circlepinkcroc =[[49, 52.2, 3, 0.7], [49, 65, 0, 0.7], [49, 89, 0, 0.7]];
var csz_circlepinkcroc =13.50;
var tsz_circlepinkcroc = [24,36,60];

var cst_circleblsaff =[[50.7, 49.3, 3, 0.7], [50.7, 66, 0, 0.7], [50.7, 89, 0, 0.7]];
var csz_circleblsaff =13;
var tsz_circleblsaff = [24,36,60];

var cst_iphonese2020 =[[50, 30, 0, 0.7], [50, 47, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphonese2020 =4.60;
var tsz_iphonese2020= [24,36,60];

var cst_iphone12 =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone12 =4.90;
var tsz_iphone12= [24,36,60];

var cst_iphone12pro =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone12pro =4.90;
var tsz_iphone12pro = [24,36,60];

var cst_iphone12promax =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone12promax =4.90;
var tsz_iphone12promax= [24,36,60];

var cst_iphone12mini =[[50, 31, 0, 0.7], [50, 46, 0, 0.7], [50, 83, 0, 0.7]];
var csz_iphone12mini =4.90;
var tsz_iphone12mini= [24,36,60];

var cst_s20 =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_s20 =5.00;
var tsz_s20= [24,36,60];

var cst_s20plus =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_s20plus =5.00;
var tsz_s20plus= [24,36,60];

var cst_s20ultra =[[50, 45.5, 0, 0.7], [50, 58, 0, 0.7], [50, 83, 0, 0.7]];
var csz_s20ultra =5.00;
var tsz_s20ultra= [24,36,60];

var cst_cardholderpinkpython =[[50.5, 41, 0, 0.7], [50.5, 57, 0, 0.7], [50.5, 65, 0, 0.7]];
var csz_cardholderpinkpython =5.00;
var tsz_cardholderpinkpython = [24,36,60];

var cst_luggagetagpinkpython =[[40, 55, 0, 0.7], [40, 70, 0, 0.7], [40, 84, 0, 0.7]];
var csz_luggagetagpinkpython =5.65;
var tsz_luggagetagpinkpython = [24,36,60];

var cst_passportpinkpython =[[63, 89, 0, 0.7], [63, 89, 0, 0.7], [63, 89, 0, 0.7]];
var csz_passportpinkpython =5.7;
var tsz_passportpinkpython = [24,36,60];
